import { Box, Button, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

const LaunchpadSuccessPage = () => {
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);
  const navigate = useNavigate();

  const goBack = () => {
    navigate(`/${routes.settings}`);
    setUpgradeDialogSource(null);
  };

  return (
    <Grid
      item
      xs
      container
      alignItems="center"
      justifyContent={"center"}
      sx={{
        backgroundColor: "green.dark",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }}
    >
      <Box
        sx={{
          backgroundColor: "green.main",
          p: { xs: 2, md: 10 },
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          gutterBottom
          textAlign="center"
          sx={{ mb: 2, color: "white" }}
        >
          🎉 Thanks for sharing! We're putting together your personalized plan
          right now.
        </Typography>

        <Typography textAlign="center" sx={{ color: "white" }}>
          Keep an eye on your inbox — we'll be in touch soon with your next
          steps and details for your first group coaching session.
          <br />
          We can't wait to see what you'll build. 💜
        </Typography>

        <Grid item container justifyContent="center" sx={{ mt: 3 }}>
          <Button onClick={goBack} sx={{ color: "yellow.main" }}>
            Go to Dashboard{" "}
            <Box
              component="i"
              className="fa-solid fa-arrow-right"
              sx={{ ml: 1 }}
            />
          </Button>
        </Grid>
      </Box>
    </Grid>
  );
};

export default LaunchpadSuccessPage;
